import { atom } from "jotai";

export type ForwardCurveCurve = {
  columnId: string;
  displayName: string;
};

export type ForwardCurveWindowState = {
  open: boolean;
  curves: ForwardCurveCurve[];
};

export const forwardCurveWindowAtom = atom<ForwardCurveWindowState>({
  open: false,
  curves: [],
});

export const forwardCurveVisibleAtom = atom<Record<string, boolean>>({});

export const forwardCurveExpandedAtom = atom<boolean>(false);
